import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable()
export class ScriptLoaderService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadScript(scriptUrl: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement('script');
      script.type = 'text/javascript';
      script.src = scriptUrl;
      script.onload = () => {
        console.log(`Loaded script: ${scriptUrl}`);
        resolve();
      };
      script.onerror = (error: any) => {
        console.error(`Could not load script: ${scriptUrl}`, error);
        reject(error);
      };
      this.renderer.appendChild(document.head, script);
    });
  }
}
